<template>
  <NavBar />
  <router-view />
  <FooterBar />
</template>

<script setup>
import NavBar from '@/components/New/NavBar.vue'
import FooterBar from '@/components/New/FooterBar.vue'
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 正确方案：只让 html 正常滚动，不锁死任何页面！ */
html {
  overflow-y: auto;
  /* 正常滚动 */
  overflow-x: hidden;
  background: #050505;
  color: #fff;
  font-family: "Inter", "PingFang SC", sans-serif;
  scroll-behavior: smooth;
}

/* body 不设置任何滚动！！！ */
body {
  min-height: 100vh;
  /* 这里什么 overflow 都不要写！ */
}

/* #app 也不设置任何 overflow！ */
#app {
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>